import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import VueRouter from 'vue-router'
import VModal from 'vue-js-modal'
import Lightbox from 'vue-my-photos'
import VueLazyload from 'vue-lazyload'
import App from './App.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { faFontAwesome } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import IndexPage from './pages/index/Index.vue'
import AboutUsPage from './pages/aboutus/Index.vue'
import GalleryPage from './pages/gallery/Index.vue'
import SermonsPage from './pages/sermons/Index.vue'
import SermonsLivePage from './pages/sermonsLive/Index.vue'
// import SermonsRemotePage from './pages/sermonsLive/Remote.vue'
import ReservePage from './pages/reserve/Index.vue'

//import './Variables.scss';


Vue.config.productionTip = false
Vue.use(VueRouter)
 
//Modals
Vue.use(VModal)

//lightbox
Vue.use(Lightbox)

//lazyload
Vue.use(VueLazyload)
 
//Font Awesome
library.add(faUserSecret);
library.add(faFontAwesome);
Vue.component('font-awesome-icon', FontAwesomeIcon)

const routes = [
  { path: '/', name: "index", component: IndexPage },
  { path: '/aboutus', name: "aboutus", component: AboutUsPage },
  { path: '/gallery/:filter?', name: "gallery", component: GalleryPage },
  { path: '/sermons/:videoid?', name: "live", component: SermonsPage },
  { path: '/sermons/live/:presentationid/:theme?', name: "sermonslive", component: SermonsLivePage },
  // { path: '/sermons/remote/:presentationid', name: "sermonsRemote", component: SermonsRemotePage },
  { path: '/live', redirect: { name: 'live' } },
  { path: '/sermons/:videoid?', name: "sermons", component: SermonsPage },
  { path: '/reserve/:phone?/:name?', name: "reserve", component: ReservePage},
  { path: '*', component: IndexPage },
]
 
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

const router = new VueRouter({
  mode: "history",
  routes, // short for `routes: routes`
  scrollBehavior: function (to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return { x: 0, y: 0 };
  },
})

if (window.location.href.indexOf("dvlp") == -1) {
  //Google analytics
  Vue.use(VueAnalytics, {
    id: 'UA-156069780-1',
    router
})
}

new Vue({
  el: '#app',
  router,
  render: h => h(App)
}).$mount('#app')